import type { StudyPlanType } from '@openeducation/oe-rn-shared-types';

import StudyPlanDao from '../dao/study-plan.dao';
import type { Environment } from '../interfaces/environment';

export abstract class StudyPlanService {
  static setStudyPlan(
    env: Environment,
    personId: number,
    studyPlanType: StudyPlanType
  ): Promise<string> {
    return StudyPlanDao.setStudyPlan(env, personId, studyPlanType);
  }
}
